import { useQuery } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { getBrands } from 'src/api/getBrands/getBrands';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

export const useGetBrands = () => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  return useQuery({
    queryKey: [QueryKeys.BRANDS],
    queryFn: getBrands,
    onError: (e: Error) => {
      showSnackbar({
        message: e.message,
        status: SnackbarStatus.ERROR,
      });
      captureException(e);
    },
  });
};
